<template>
  <div class="page" :style="{ background:colors.coral }">

    <top-bar fixed />

    <section class="names-hero" :style="{ color: colors.paleYellow }">
        <h1>Dilara Semerci</h1>
        <h2 class="ampersand" style="margin-top: 40px;">&amp;</h2>
        <!-- v-parallax="0.1"  -->
        <h1>Regis Frey</h1>
    </section>

    <section class="location-section istanbul-location" style="padding-top: 300px; padding-bottom: 150px;">

      <vector-canvas
        vector="MaidensTower"
        class="location-art istanbul-location__image"
        :color="colors.coralDark"
        align-x="mid"
        align-y="max"
        scale="cover"
        fit-parent
        />
      
      <!-- v-parallax="0.2" -->
      <date-block
        :month="$t('month-june')" :day="16"
        :city="$t('istanbul')" :location="$t('turkey')"
        :fg="colors.coral" :bg="colors.paleYellow"
        class="location-date"
        />
      

      <button-block
          class="right-float-button"
          :label="$t('more-information')"
          :fg="colors.coral"
          :bg="colors.paleYellow"
          v-on:click="$router.push('istanbul')"
          style="top: auto; bottom: 28%; right: 5%;"
          />
    </section>

    <section
      class="location-section pittsburgh-location"
      :style="{ backgroundColor: colors.indigo, justifyContent: 'flex-end' }"
      >

      <vector-canvas
        vector="Schenley"
        class="location-art pittsburgh-location__image"
        :color="colors.indigoDark"
        align-x="mid"
        align-y="max"
        :y-max="1000"
        scale="cover"
        fit-parent
        />

      <!-- v-parallax="0.1" -->
      <date-block
        :month="$t('month-august')" :day="3"
        :city="$t('pittsburgh')" :location="$t('pa-usa')"
        :fg="colors.indigo" :bg="colors.paleYellow"
        class="location-date pittsburgh-location__date"
        />
      
      <button-block
          class="right-float-button"
          :label="$t('more-information')"
          :fg="colors.indigo"
          :bg="colors.paleYellow"
          v-on:click="$router.push('pittsburgh')"
          style="top: auto; bottom: 28%; right: 5%;"
          />
    </section>

    <section
      class="rsvp-section"
      :style="{ backgroundColor: colors.indigoDark }">

      <rsvp-form
        :fg="colors.tanDark"
        :bg="colors.tan"
        />

    </section>

  </div>
</template>

<script>
import DateBlock from '@/components/DateBlock.vue'
import ButtonBlock from '@/components/ButtonBlock.vue'
// import ButtonLink from '@/components/ButtonLink.vue'
// import PaperCard from '@/components/PaperCard.vue'
// import MapboxBlock from '@/components/MapboxBlock.vue'
import TopBar from '@/components/TopBar.vue'
import VectorCanvas from '@/components/VectorCanvas.vue'
import RsvpForm from '@/components/RsvpForm.vue'
import { colors } from '@/colors.js'

export default {
  name: 'home',
  data () {
    return {
      colors,
      infoButtonStyle: {
        zIndex: 999999,
        width: '360px',
        position: 'absolute',
        right: '10%',
        top: '20%',
        height: '55px',
        overflow: 'visible',
        padding: '10px',
      }
    }
  },
  components: {
    DateBlock,
    ButtonBlock,
    // ButtonLink,
    // PaperCard,
    // MapboxBlock,
    TopBar,
    VectorCanvas,
    RsvpForm,
  }
}
</script>

<style lang="scss">
h1,h2,h3,h4,h5 {
  margin:0; padding:0;
}
.names-hero {
  padding: 25px 15px;
  padding-top: 150px;
  padding-bottom: 0;
  margin-bottom: -25px;
  z-index: 4000;
  background-color: transparent;
  font-size: 4.25em;
  text-align: center;
  line-height: 1.5em;
  position: relative;
  box-sizing: border-box;

  h1 {
    z-index: 1;
    position: relative;
  }

  h1:first-child {
    margin-bottom: 0.5em;
  }

  // position relative to it's container
  // use it's container to leave gap between names, 
  // then position relative to that
  .ampersand {
    font-size: 6em;
    color: rgba(0,0,0,0.4);
    z-index: 0;
    height: 100px;
  }
}

.page {
  overflow:auto;
  min-height: 100vh;
}

.location-section {
  position: relative;
  padding: 100px 50px;
}
.location-art {
  z-index: 10;
}
.location-date {
  position: relative;
  z-index: 100;
}

.pittsburgh-location__image {
}
.pittsburgh-location__date {
}

.rsvp-section {
  padding: 50px;
}

@media (max-width: 700px) {
  .location-section {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .button-block.right-float-button {
    // cancel position absolute
    position: relative;
    width: auto;
    right: auto;
    top: auto;
    height: auto;
    padding: initial;
    // and stretch
    align-self: stretch;
  }
  .rsvp-section {
    padding: 10px;
  }
}
</style>
